<template>
  <div class="home">


    <div class="creppy-white-blass-wait">
      <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">Bewerben</h5>

      <br class="no-move"/>

    </div>

    <div class="main-title container">


      <br class="no-move"/>


      <h1 class="headers-text text-dark"><strong>Einer von uns</strong></h1>
      <p class="body-title-lighter text-dark"><strong>Du möchtest das LabyHelp Team beitreten. Dann erfährst du hier alle Wichtigen Informationen.</strong></p>

      <br class="no-move"/>
      <br class="no-move"/>

      <b-card-group deck>

        <b-card>

          <h2 class="text-normal-title">
            <fai style="color:black;" :icon="['fas', 'AngleDoubleRight']" size="1x"/>
            Moderator & Supporter
          </h2>

          <a class="btn btn-primary" href="https://drive.google.com/u/0/uc?id=12ELKJC4KYtDTOHmohsonZva5dlt6Vl09&export=download" >
            Voraussetzungen
          </a>
        </b-card>

          <b-card>

              <h2 class="text-normal-title">
                  Eine andere Position in der du LabyHelp unterstützen kannst?
              </h2>

          </b-card>


      <!--  <b-card>
          <h2 class="text-normal-title">
            <fai style="color:black;" :icon="['fas', 'AngleDoubleRight']" size="1x"/>
            Content
          </h2>

          <a class="btn btn-primary" href="https://drive.google.com/u/0/uc?id=1QYNq6TAm6ftS5fa2MsDMofg6IgH4Cr1s&export=download" >
            <a>Voraussetzungen</a>
          </a>
        </b-card> -->
      </b-card-group>


      <br class="no-move"/>

      <h1 class="headers-text text-dark"><strong>Bewerbung senden</strong></h1>
      <b-button href="mailto:apply@labyhelp.de" size="lg">Email schreiben</b-button>

      </div>

      <br class="no-move"/>
     <br class="no-move"/>
     <br class="no-move"/>

      <div class="" style="alignment: bottom">

        <div class="" style="alignment: bottom">
          <p class="smaller-end-text">© {{today.getFullYear()}}
            <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
            <a style="color: #6868b3"
               href="https://labyhelp.de/support">Support</a>
            -
            <a style="color: #6868b3"
               href="https://labyhelp.de/apply">Apply</a>
            -
            <a style="color: #6868b3"
               href="https://labyhelp.de/creator">Creator</a>
            -
            <a style="color: #6868b3"
               href="ts3server://labyhelp.de">TeamSpeak</a>
          </p>
        </div>

      </div>

    </div>
</template>

<script>
export default {
  name: "Team",
  data() {
    return {
      today: new Date()
    }
  },
}
</script>

<style scoped>

</style>